import { render } from "./GamePage.vue?vue&type=template&id=2c2903a8&scoped=true&ts=true"
import script from "./GamePage.vue?vue&type=script&lang=ts"
export * from "./GamePage.vue?vue&type=script&lang=ts"

import "./GamePage.vue?vue&type=style&index=0&id=2c2903a8&lang=scss&scoped=true"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2903a8"]])

export default __exports__